module.exports = __webpack_public_path__ + "static/img/29.9.0474252.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/29.9.jpg
// module id = 1sH9
// module chunks = 0